import {h, Fragment} from "preact"
export default ({ flairTags = [], soldOut, isCategorySelected }) => {
  const isPreferredSeller = flairTags.some((tag) => tag === "Preferred Seller");

  if (soldOut)
    return (
      <>
        {isPreferredSeller && (
          <div
            className={`app--listing-card-flair-tag app--listing-card-flair-tag--indigo flair-mr`}
          >
            <div className="flex items-center">
              <svg
                width="14"
                height="12"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.219971"
                  width="16"
                  height="16"
                  rx="8"
                  fill="#606BFA"
                />
                <path
                  d="M11.5 6.21997L7.5 10.22L5.5 8.21997"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span> Preferred Seller</span>
          </div>
        )}
        <div className="app--listing-card-flair-tag flex-tag app--listing-card-flair-tag--yellow app--listing-card-flair-tag--sold-out">
          Sold Out
        </div>
      </>
    );

  if (window.cj.nosto.newSearchFeatureEnabled && !isCategorySelected) {
    if (!flairTags?.length) return;
    const RENDERABLE_TAGS = [
      "Free Shipping",
      "Ships Fast",
      "Order Soon",
      "Low Stock",
      "Preferred Seller",
    ];
    const tagsToRender = flairTags.filter((tag) =>
      RENDERABLE_TAGS.includes(tag),
    );

    if (tagsToRender.length > 0)
      return tagsToRender.map((tag) => {
        const tagClassMapping = {
          "Free Shipping": "app--listing-card-flair-tag--green-new flair-mr",
          "Ships Fast": "app--listing-card-flair-tag--green-new flair-mr",
          "Order Soon": "app--listing-card-flair-tag--yellow-new flair-mr",
          "Low Stock": "app--listing-card-flair-tag--yellow-new flair-mr",
          "Preferred Seller": "app--listing-card-flair-tag--indigo flair-mr",
        };

        const className =
          tagClassMapping[tag] || "app--listing-card-flair-tag--blue";

        if (tag.includes("Preferred"))
          return (
            <div class={`app--listing-card-flair-tag ${className}`}>
              <div class="flex items-center">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 17 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.219971"
                    width="16"
                    height="16"
                    rx="8"
                    fill="#606BFA"
                  />
                  <path
                    d="M11.5 6.21997L7.5 10.22L5.5 8.21997"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>{tag}</span>
            </div>
          );
        else
          return (
            <div class={`app--listing-card-flair-tag flex-tag ${className}`}>{tag}</div>
          );
      });
  } else {
    if (!flairTags?.length) return;

    const RENDERABLE_TAGS = [
      "Free Shipping",
      "Ships Fast",
      "Order Soon",
      "Low Stock",
    ];
    const tagsToRender = flairTags.filter((tag) =>
      RENDERABLE_TAGS.includes(tag),
    );

    if (tagsToRender.length > 0)
      return tagsToRender.map((tag) => {
        const className = tag.includes("Ship")
          ? "app--listing-card-flair-tag--green"
          : "app--listing-card-flair-tag--yellow";
        return (
          <div class={`app--listing-card-flair-tag flex-tag ${className}`}>{tag}</div>
        );
      });
  }
  return null;
};
